// extracted by mini-css-extract-plugin
export default {"container":"color-picker_container__Ik73x","pickerWrapper":"color-picker_pickerWrapper__JLglo","summary":"color-picker_summary__pwQ1j"};